import { fetchGraphQLRequest } from 'src/api/graphql-api';
import * as notificationOps from './notificationOperations';
import { XptNotification } from './notificationModels';

/** All persistent notifications + non-persistent notifications from the last 15 days (read/unread)
 * for the current user (backend scoped by the Cognito identity). */
export const getMyNotifications = async (): Promise<XptNotification[]> => {
  const data = await fetchGraphQLRequest<{ listMyNotifications: XptNotification[] }>({
    query: notificationOps.listMyNotifications,
    variables: {},
    requestName: 'listMyNotifications',
    requestType: 'query'
  });
  return data.listMyNotifications ?? [];
};

/** Advance the caller's read watermark to now(): all currently-visible non-persistent items
 * become read (greyed). */
export const markMyNotificationsRead = async (): Promise<void> => {
  await fetchGraphQLRequest<{ markNotificationsRead: { numberOfRecordsUpdated: number } }>({
    query: notificationOps.markNotificationsRead,
    variables: {},
    requestName: 'markNotificationsRead',
    requestType: 'mutation'
  });
};
